module.exports = "<div class=\"face\">\n  <label>{{ siglaFace | empty: '-' }}</label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/procedimento-faces/procedimento-faces.component.html
// module id = ./src/app/components/procedimento-faces/procedimento-faces.component.html
// module chunks = main